<div class="card flex flex-col gap-3 p-4">
  <h3 class="font-semibold">
    {{ 'project.steps.rfp.invitationList.matrix.selectedProvider' | transloco }}
  </h3>
  <app-model-field-select
    id="selected-tool-picker"
    testId="selected-tool-picker"
    [options]="tools()"
    optionLabel="translatedName"
    optionValue="id"
    [showClear]="false"
    [value]="tool().id"
    (valueChange)="toolChange.emit($event)"
  />
  <div class="grid grid-cols-2 gap-2">
    @for (tile of tiles(); track tile.labelKey) {
      <div [class.col-span-2]="tile.wide">
        <app-metric-tile
          [label]="tile.labelKey | transloco"
          [value]="tile.value | appNumber: '1.0-0'"
          suffix=" %"
          [inset]="true"
        />
      </div>
    }
  </div>
  <span class="text-sm" [class.text-green]="preferred()" data-testid="selected-tool-assessment">
    {{ assessmentKey() | transloco }}
  </span>
  <div class="flex flex-wrap gap-2">
    <p-button
      [label]="participantLabelKey() | transloco"
      [icon]="participantIcon()"
      size="small"
      [disabled]="participantDisabled()"
      (onClick)="selectAsParticipant()"
      data-testid="select-as-participant"
    />
    <p-button
      [label]="'project.steps.rfp.invitationList.matrix.doNotInvite' | transloco"
      severity="secondary"
      size="small"
      [disabled]="removeDisabled()"
      (onClick)="doNotInvite()"
      data-testid="do-not-invite"
    />
  </div>
</div>
